import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from './auth';

function useSyncBeersales(): void {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    // /get-data sincroniza a conta do próprio usuário logado. Nas telas de admin o
    // trabalho é sobre a conta de outro cliente, então essa chamada não tem efeito
    // útil ali — e concorre com a sincronização disparada manualmente.
    if (location.pathname.startsWith('/admin')) return;

    const sync = () => {
      if (document.visibilityState === 'visible') {
        api.post('/get-data').catch(error => {
          console.error('Erro na sincronização:', error);
        });
      }
    };

    const intervalo = setInterval(sync, 33000);
    sync();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        sync();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(intervalo);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [location.pathname, user]);
}

export { useSyncBeersales };
